import type { HeadingLevel } from '@/features/content/TextUnit';

import { QuestionContent } from './QuestionContent';
import type { NormalizedDisclosureData } from './questionNormalizer';
import styles from './SolutionSection.module.css';

interface SolutionSectionProps {
  disclosure?: NormalizedDisclosureData;
  headingLevel?: HeadingLevel;
}

export function SolutionSection({
  disclosure,
  headingLevel = 4,
}: SolutionSectionProps) {
  if (!disclosure?.isVisible || disclosure.units.length === 0) {
    return null;
  }

  return (
    <details className={styles.section}>
      <summary className={styles.summary}>{disclosure.summaryLabel}</summary>
      <div className={styles.body}>
        <QuestionContent headingLevel={headingLevel} units={disclosure.units} />
      </div>
    </details>
  );
}

